import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addDischargeArrayItem,
  removeDischargeArrayItem,
} from "../../../../Redux/actions/dischargeActions";

const ACTIVITIES = [
  { carePlanCode: "CP001", carePlanName: "Bed Rest" },
  { carePlanCode: "CP002", carePlanName: "Light Activity" },
  { carePlanCode: "CP003", carePlanName: "Walking Allowed" },
  { carePlanCode: "CP004", carePlanName: "Avoid Heavy Lifting" },
  { carePlanCode: "CP005", carePlanName: "No Driving" },
  { carePlanCode: "CP006", carePlanName: "Physiotherapy Exercises" },
  { carePlanCode: "CP007", carePlanName: "Avoid Strenuous Exercise" },
  { carePlanCode: "CP008", carePlanName: "Medication Management" },
];

export default function CarePlan() {
  const dispatch = useDispatch();
  const dischargeCarePlanDtls = useSelector(
    (state) => state.discharge?.dischargeCarePlanDtls || []
  );

  const isChecked = (carePlanCode) => {
    return dischargeCarePlanDtls.some((item) => item.carePlanCode === carePlanCode);
  };

  const handleToggleActivity = (act) => {
    const existingIndex = dischargeCarePlanDtls.findIndex(
      (item) => item.carePlanCode === act.carePlanCode
    );

    if (existingIndex > -1) {
      dispatch(removeDischargeArrayItem("dischargeCarePlanDtls", existingIndex));
    } else {
      dispatch(
        addDischargeArrayItem("dischargeCarePlanDtls", {
          carePlanId: dischargeCarePlanDtls.length + 1,
          carePlanCode: act.carePlanCode,
          carePlanName: act.carePlanName,
          status: 1,
        })
      );
    }
  };

  return (
    <div className="bg-white rounded-lg border border-gray-100 p-4 shadow-sm hover:shadow-md transition-shadow">
      <h3 className="text-sm font-bold text-teal-700 mb-2 flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-teal-600"></span>
        11. Care Plan ({dischargeCarePlanDtls.length} Selected)
      </h3>
      <label className="block text-xs font-semibold mb-2 text-gray-700">
        Select Activity Type
      </label>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-y-2.5 gap-x-2 mb-3 text-xs font-medium text-gray-700">
        {ACTIVITIES.map((act) => {
          const checked = isChecked(act.carePlanCode);
          return (
            <label
              key={act.carePlanCode}
              className="flex items-center gap-2 cursor-pointer hover:text-teal-800 transition"
            >
              <input
                type="checkbox"
                checked={checked}
                onChange={() => handleToggleActivity(act)}
                className="rounded text-teal-600 focus:ring-teal-500"
              />
              <span className={checked ? "text-teal-900 font-semibold" : ""}>
                {act.carePlanName}
              </span>
            </label>
          );
        })}
      </div>
    </div>
  );
}
